/* ProgressRenderer.js */

"use strict";

const Loader = require("@gluenetworks/fancy_loading_mask_gl");
const {Control} = require("@gluenetworks/steve_ui_core");
const {Button} = Control.Action;

/**
 * @class ProgressRenderer
 * @listens ProgressRenderer#event:Progress
 */
class ProgressRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = this._createRootElement();
        this._rootElem.component = this._model;

        this._loader = new Loader({
            darkTheme: true,
            shown: true,
            message: "Copying your devices...",
        });

        this._hideButton = new Button({
            label: "Hide",
            darkTheme: true,
        });

        this._registerListeners();
        this.render();
    }

    get rootElement() {
        return this.getRootElement();
    }

    get model() {
        return this.getModel();
    }

    _registerListeners() {
        this._hideButton.on("UserClick", this._onHideButtonClick.bind(this));
        this._model.on("progress", this._onProgress.bind(this));
    }

    _unregisterListeners() {
        this._hideButton.removeListener("UserClick", this._onHideButtonClick);
        this._model.removeListener("progress", this._onProgress);
    }

    shutdown() {
        this._unregisterListeners();
        this._rootElem.remove();

        return Promise.all([this._loader.shutdown(), this._hideButton.shutdown()])
            .then(() => {
                this._model = undefined;
                this._rootElem = undefined;
            })
            .catch(/*err => {}*/); // Handle errors if necessary
    }

    render() {
        this._rootElem.innerHTML = "";
        const root = document.createDocumentFragment();

        const loaderContainer = document.createElement("div");
        loaderContainer.className = "loader-container";
        loaderContainer.appendChild(this._loader.renderer.rootElement);
        root.appendChild(loaderContainer);

        const buttonContainer = document.createElement("div");
        buttonContainer.className = "actions_container";
        buttonContainer.appendChild(this._hideButton.renderer.rootElement);
        root.appendChild(buttonContainer);

        this._rootElem.appendChild(root);
        return Promise.resolve();
    }

    getRootElement() {
        return this._rootElem;
    }

    getModel() {
        return this._model;
    }

    _createRootElement() {
        const rootElement = document.createElement("div");
        rootElement.classList.add("configure-audit-progress-renderer", "modal_feedback_container");
        rootElement.component = this._model;
        return rootElement;
    }

    _onProgress(workId, msg) {
        if (workId) {
            this._model._data._workId = workId;
        }
        this._hideButton.setDisabled(false);
        this._loader.showProgress(msg);
    }

    _onHideButtonClick() {
        this._model.close();
    }
}

module.exports = ProgressRenderer;
